import React, { useEffect, useState } from "react";
import axios from "axios";

import { Row, Col, Card, Typography, Table, Button, Space } from "antd";
import { BarChartOutlined } from "@ant-design/icons";

import "./css/dashboard.css";

import Barchart from "./chartJs/Barchart";
import StackBarchart from "./chartJs/StackBarchart";

const { Title, Text } = Typography;

const cardStyle = {
  height: 420,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const cardStyle2 = {
  height: 200,
  borderRadius: 12,
  boxShadow: "0 6px 16px rgba(0,0,0,0.06)",
  overflow: "hidden"
};

const Dashboard7_4 = () => {
  let xURL = "";

  xURL = "https://research.rihes.cmu.ac.th/api/";

  const columns7_4_3 = [
    {
      title: "วิจัย",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ศึกษา",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "บริการวิชาการ",
      dataIndex: "c3",
      key: "c3",
      align: "center"
    }
  ];

  const data7_4_3 = [
    {
      key: "1",
      c1: "0",
      c2: "0",
      c3: "2"
    }
  ];

  const columns7_4_4 = [
    {
      title: "กลุ่มผู้ตอบแบบสอบถาม",
      dataIndex: "c1",
      key: "c1",
      align: "center",
      render: text =>
        <div style={{ textAlign: "left" }}>
          {text}
        </div>
    },
    {
      title: "2567",
      key: "c2",
      align: "center",
      children: [
        {
          title: "คะแนนเฉลี่ย",
          dataIndex: "c2_1",
          key: "c2_1",
          align: "center"
        },
        {
          title: "ระดับ",
          dataIndex: "c2_2",
          key: "c2_2",
          align: "center"
        }
      ]
    },
    {
      title: "2568",
      key: "c3",
      align: "center",
      children: [
        {
          title: "คะแนนเฉลี่ย",
          dataIndex: "c3_1",
          key: "c3_1",
          align: "center"
        },
        {
          title: "ระดับ",
          dataIndex: "c3_2",
          key: "c3_2",
          align: "center"
        }
      ]
    }
  ];

  const data7_4_4 = [
    {
      key: "1",
      c1: "1. กลุ่มคณาจารย์และนักวิจัย",
      c2_1: "4.58",
      c2_2: "ดีมาก",
      c3_1: "4.44",
      c3_2: "ดี"
    },
    {
      key: "2",
      c1: "2. กลุ่มผู้ปฏิบัติงานสายปฏิบัติการ",
      c2_1: "4.15",
      c2_2: "ดี",
      c3_1: "4.56",
      c3_2: "ดีมาก"
    },
    {
      key: "3",
      c1: "3. กลุ่มนักศึกษา",
      c2_1: "3.87",
      c2_2: "ดี",
      c3_1: "4.55",
      c3_2: "ดีมาก"
    },
    {
      key: "4",
      c1: "4. กลุ่มผู้มีส่วนเกี่ยวข้องภายนอก",
      c2_1: "4.47",
      c2_2: "ดี",
      c3_1: "4.54",
      c3_2: "ดีมาก"
    }
  ];

  const columns7_4_8 = [
    {
      title: "หน่วยงานตรวจสอบ",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "ค่ามาตรฐาน",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    },
    {
      title: "จำนวนการกระทำผิด ระเบียบบัญชีและพัสดุ",
      key: "c3",
      align: "center",
      children: [
        {
          title: "64",
          dataIndex: "c3_64",
          key: "c3_64",
          align: "center"
        },
        {
          title: "65",
          dataIndex: "c3_65",
          key: "c3_65",
          align: "center"
        },
        {
          title: "66",
          dataIndex: "c3_66",
          key: "c3_66",
          align: "center"
        },
        {
          title: "67",
          dataIndex: "c3_67",
          key: "c3_67",
          align: "center"
        },
        {
          title: "68",
          dataIndex: "c3_68",
          key: "c3_68",
          align: "center"
        }
      ]
    }
  ];

  const data7_4_8 = [
    {
      key: "1",
      c1: "หน่วยตรวจสอบภายใน",
      c2: "0",
      c3_64: 0,
      c3_65: 0,
      c3_66: 0,
      c3_67: 0,
      c3_68: 0
    },
    {
      key: "2",
      c1: "สตง.",
      c2: "0",
      c3_64: 0,
      c3_65: 0,
      c3_66: 0,
      c3_67: 0,
      c3_68: 0
    },
    {
      key: "3",
      c1: "บริษัทตรวจสอบบัญชีจากภายนอก",
      c2: "0",
      c3_64: 0,
      c3_65: 0,
      c3_66: 0,
      c3_67: 0,
      c3_68: 0
    }
  ];

  const columns7_4_9 = [
    {
      title: "ปี",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "คะแนน",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_4_9 = [
    {
      key: "1",
      c1: "2568",
      c2: "รอผลคะแนนประเมินจากคณะกรรมการ"
    },
    {
      key: "2",
      c1: "2567",
      c2: "330"
    },
    {
      key: "3",
      c1: "2566",
      c2: "199"
    },
    {
      key: "4",
      c1: "2565",
      c2: "232.7"
    }
  ];

  const columns7_4_10 = [
    {
      title: "ด้ายบริหาร",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_4_10 = [
    {
      key: "1",
      c1: "จำนวนครั้งผู้บริหาร/บุคลากรที่ผิดวินัยร้ายแรง",
      c2: "0"
    },
    {
      key: "2",
      c1: "จำนวนครั้งผู้บริหาร/บุคลากรที่ผิดจริยธรรม",
      c2: "1"
    }
  ];

  const columns7_4_13 = [
    {
      title: "ผลประเมิน CMU-OIT",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "2568",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_4_13 = [
    {
      key: "1",
      c1: "สถาบันฯ",
      c2: "94.50"
    }
  ];

  const columns7_4_18 = [
    {
      title: "ปี",
      dataIndex: "c1",
      key: "c1",
      align: "center"
    },
    {
      title: "kWh",
      dataIndex: "c2",
      key: "c2",
      align: "center"
    }
  ];

  const data7_4_18 = [
    {
      key: "1",
      c1: "2568",
      c2: "41,932.15"
    }
  ];

  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          ผลลัพธ์ด้านการนำองค์กรและการกำกับดูแลองค์กร
        </Title>
      </div>

      {/* Row 1 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-1 ลำดับการแข่งขันของสถาบันฯ กับคู่เทียบ Top in Universities in Public Health area (SCIMAGO) Institute Ranking"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_4/file_7_4_1_ลำดับการแข่งขันของสถาบันฯ_Top_University_SciVal.xlsx",
                    "_blank"
                  )}
              >
                ลำดับการแข่งขันของสถาบันฯ Top University SciVal
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-2 ระดับความคิดเห็นของบุคลากรต่อการนำองค์กรของผู้บริหาร"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    "https://app.powerbi.com/view?r=eyJrIjoiMDVkODg3ZjctNjQ1MS00YzdhLThkNDktNzNhZmI5ZmVhZGVhIiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                    "_blank"
                  )}
              >
                ระดับความคิดเห็นของบุคลากรต่อการนำองค์กรของผู้บริหาร
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 2 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-3 จำนวน KM ที่นำไปสู่วัตกรรมองค์กร"
          >
            <div style={{ height: "90px" }} />
            <Table
              columns={columns7_4_3}
              dataSource={data7_4_3}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-4 ความพึงพอใจของพันธมิตรต่อการบริหารของผู้นำองค์กร"
          >
            <Table
              columns={columns7_4_4}
              dataSource={data7_4_4}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 3 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-5 ความเชื่อมั่นของลูกค้าที่มีต่อการดำเนินงานของสถาบันฯ"
          >
            <div
              style={{
                height: 280,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Space size="large">
                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiN2NiOTBkNjItNmU5NS00MjdkLWE0MzItYjhmMTI2MDUyZjc3IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  GI
                </Button>

                <Button
                  type="primary"
                  icon={<BarChartOutlined />}
                  size="large"
                  style={{
                    borderRadius: 10,
                    height: 50,
                    padding: "0 28px",
                    fontWeight: 500
                  }}
                  onClick={() =>
                    window.open(
                      "https://app.powerbi.com/view?r=eyJrIjoiMGI5ZGVkMjMtM2EwNC00OTVkLTg0ZmItYTVkOTVmOTY5NGM2IiwidCI6ImNmODFmMWRmLWRlNTktNGMyOS05MWRhLWEyZGZkMDRhYTc1MSIsImMiOjEwfQ%3D%3D",
                      "_blank"
                    )}
                  ghost
                >
                  Clinic
                </Button>
              </Space>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-6 ผลประเมินคุณลักษณะและการนำองค์กรของผู้บริหาร"
          >
            <Table
              columns={columns7_4_4}
              dataSource={data7_4_4}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 4 */}

      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-7 ผลประเมินการบริหารงานของผู้บริหาร"
          >
            <Table
              columns={columns7_4_4}
              dataSource={data7_4_4}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-8 ผลการตรวจสอบด้านการเงินภายในและภายนอก"
          >
            <Table
              columns={columns7_4_8}
              dataSource={data7_4_8}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 5 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-9 ผลประเมิน CMU-EdPEx / TQA"
          >
            <Table
              columns={columns7_4_9}
              dataSource={data7_4_9}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-10 การปฏิบัติตามกฏหมายและกฏระเบียบข้อบังคับ"
          >
            <Table
              columns={columns7_4_10}
              dataSource={data7_4_10}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 6 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-11 มาตรฐานการปฏิบัติงานต่างๆ ที่ได้รับรองจากหน่วยงานภายนอก"
          >
            <div
              style={{
                height: 60,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(xURL + "dashboard4/7_4/pic_7_4_11.png", "_blank")}
              >
                มาตรฐานการปฏิบัติงานต่างๆ ที่ได้รับรองจากหน่วยงานภายนอก
              </Button>
            </div>

            <a
              href={xURL + "dashboard4/7_4/file_7_4_11.docx"}
              download="file_7_4_11.docx"
            >
              <Button
                size="small"
                style={{
                  borderRadius: 10,
                  height: 30,
                  padding: "0 28px"
                }}
              >
                ดาวน์โหลดไฟล์
              </Button>
            </a>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-12 ความกังวลของสังคมจากการดำเนินงานของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexDirection: "column",
                color: "#9aa0a6"
              }}
            >
              <div style={{ fontSize: 28 }}>📊</div>
              <div style={{ fontSize: 16, marginTop: 8 }}>ยังไม่มีข้อมูล</div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                ไม่มีข้อมูลสำหรับแสดงในขณะนี้
              </div>
              <div style={{ fontSize: 12, marginTop: 4 }}>
                (รอข้อมูล link ไฟล์พี่ทราย,พี่ก้อย)
              </div>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 7 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-13 ผลประเมิน CMU-OIT"
          >
            <div style={{ height: "90px" }} />
            <Table
              columns={columns7_4_13}
              dataSource={data7_4_13}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-14 ความเชื่อมั่นของลูกค้าต่อการประพฤติปฏิบัติอย่างมีจริยธรรมของสถาบันฯ"
          >
            <Table
              columns={columns7_4_4}
              dataSource={data7_4_4}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>

      {/* Row 8 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-15 ผลการดำเนินงานของโครงการคืนลมหายใจที่ไร้ฝุ่น"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_4/file_7_4_15ศพด_ที่ร่วมกิจกรรมปี_2566_2569_NIC.xlsx",
                    "_blank"
                  )}
              >
                ผลการดำเนินงานของโครงการคืนลมหายใจที่ไร้ฝุ่น
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-16 การสร้างผลกระทบทางสังคมของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open("https://cmu.to/CMUImpactData", "_blank")}
              >
                SROI dashboard
              </Button>
            </div>
          </Card>
        </Col>
      </Row>

      {/* Row 9 */}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-17 การสร้างผลกระทบทางเศรษฐกิจของสถาบันฯ"
          >
            <div
              style={{
                height: 80,
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
              }}
            >
              <Button
                type="primary"
                icon={<BarChartOutlined />}
                size="large"
                style={{
                  borderRadius: 10,
                  height: 50,
                  padding: "0 28px",
                  fontWeight: 500
                }}
                onClick={() =>
                  window.open(
                    xURL +
                      "dashboard4/7_4/file_7_4_17_การสร้างผลกระทบทางเศรษฐกิจของสถาบันฯ.xlsx",
                    "_blank"
                  )}
              >
                การสร้างผลกระทบทางเศรษฐกิจของสถาบันฯ
              </Button>
            </div>
          </Card>
        </Col>

        <Col xs={24} lg={12}>
          <Card
            bordered={false}
            style={{
              ...cardStyle2,
              borderTop: "4px solid rgb(172, 202, 36)"
            }}
            title="7.4-18 การลดการปล่อยก๊าซเรือนกระจกจากการผลิตพลังงานแสงอาทิตย์"
          >
          
            <Table
              columns={columns7_4_18}
              dataSource={data7_4_18}
              pagination={false}
              size="small"
              bordered
            />
          </Card>
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default Dashboard7_4;
